import { render, staticRenderFns } from "./PublicationModal.vue?vue&type=template&id=4b3849ce&scoped=true"
import script from "./PublicationModal.vue?vue&type=script&lang=js"
export * from "./PublicationModal.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./PublicationModal.vue?vue&type=style&index=1&id=4b3849ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3849ce",
  null
  
)

export default component.exports